import { Injectable } from '@angular/core';

import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class CryptojsService {

  private static SECRET_KEY: string = "6h3QCpItl4yvAhknQDFwzth4fa2AxiNf/PslUKbR1yw=";
  private iv: CryptoJS.lib.WordArray = CryptoJS.lib.WordArray.create(new Array(16));

  constructor() { }

  public encrypt(input: string) {
    const key = CryptoJS.enc.Base64.parse(CryptojsService.SECRET_KEY);
    const iv = CryptoJS.lib.WordArray.create(new Array(16).fill(0));
    const encrypted = CryptoJS.AES.encrypt(input, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC, // AES-CBC mode
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
  }

  public decrypt(encryptedResponse) {
    const key = CryptoJS.enc.Base64.parse(CryptojsService.SECRET_KEY);
    const encrypted = CryptoJS.enc.Base64.parse(encryptedResponse);
    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: encrypted },
      key,
      {
        iv: this.iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    );
    const decryptedText = CryptoJS.enc.Utf8.stringify(decrypted);
    return JSON.parse(decryptedText);
  }
}
